import clsx from 'clsx';
import HubertCombobox from 'components/HubertUI/HubertCombobox';
import { hubiversePropertyList } from '../constants/hubiversePropertyList';

interface Props {
  onSelect: (e: string) => void;
  selected: string;
  disabled?: boolean;
  includeLabel?: boolean;
}

const HubiversePropertySelect = ({ onSelect, selected, includeLabel = false, disabled = false }: Props) => {
  let idx = -1;
  if (selected) {
    idx = hubiversePropertyList.findIndex((x: any) => x.value === selected);
  }

  if (includeLabel) {
    return (
      <div className={clsx('flex flex-row justify-between gap-4', 'hubert-vertical-center text-center', 'my-4')}>
        <div className="w-1/4 max-w-1/4 min-w-1/4">Hubiverse Property</div>
        <div className="w-3/4 max-w-3/4 min-w-3/4">
          <HubertCombobox
            items={hubiversePropertyList}
            value={selected && idx > -1 ? hubiversePropertyList[idx].value : hubiversePropertyList[0].value}
            onValueChange={(e) => {
              if (onSelect && !Array.isArray(e)) {
                onSelect(e);
              }
            }}
            itemName=""
            disabled={disabled}
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <HubertCombobox
        itemName="Hubiverse Property"
        items={hubiversePropertyList}
        disabled={disabled}
        value={selected && idx > -1 ? hubiversePropertyList[idx].value : hubiversePropertyList[0].value}
        onValueChange={(e) => {
          if (onSelect && !Array.isArray(e)) {
            onSelect(e);
          }
        }}
      />
    </div>
  );
};

export default HubiversePropertySelect;
